export default {
  setGroups(state, payload) {
    state.groups = payload
  },
  SET_PLACEHOLDERS: (state, payload) => (state.placeholders = payload),
  setDocument(state, payload) {
    state.document = payload
  },
  SET_ASSOCIATE_DOCUMENTS: (state, payload) => (state.associateDocuments = payload),
  setAssociateDocumentsSync: (state, payload) => (state.associateDocumentsSync = payload),
  SET_TEMPLATES: (state, payload) => (state.templates = payload),
  SET_ASSOCIATE_DYNAMIC_FORM(state, { type, data }) {
    state.associateDynamicForm = {
      ...state.associateDynamicForm,
      [type]: data ? { ...data } : undefined
    }
  },
  SET_ASSOCIATE_DYNAMIC_FORM_AVAILABILITY(state, payload) {
    state.associateDynamicFormAvailability = payload
  }
}
